import React from "react";
import {
  Paper,
  TextField,
  InputAdornment,
  Button,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

const SearchBar = ({
  searchQuery,
  onSearchChange,
  onClearSearch,
  loading,
  tabLoading,
  resultsCount,
}) => {
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  return (
    <Paper
      elevation={0}
      sx={{
        mb: 2,
        p: 2,
        borderRadius: 2,
        bgcolor: "white",
        border: "1px solid #e5e7eb",
      }}
    >
      <TextField
        fullWidth
        placeholder="Search by flat name, owner, move-in date, or status..."
        value={searchQuery}
        onChange={onSearchChange}
        onKeyDown={handleKeyDown}
        disabled={loading || tabLoading}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: "#64748b" }} />
            </InputAdornment>
          ),
          endAdornment: searchQuery && (
            <InputAdornment position="end">
              <Button
                type="button"
                size="small"
                onClick={onClearSearch}
                disabled={loading || tabLoading}
                sx={{
                  minWidth: "auto",
                  p: 0.5,
                  color: "#64748b",
                  "&:hover": {
                    bgcolor: "#f1f5f9",
                  },
                }}
              >
                <ClearIcon fontSize="small" />
              </Button>
            </InputAdornment>
          ),
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: 2,
            bgcolor: "#f8fafc",
            "& fieldset": {
              borderColor: "transparent",
            },
            "&:hover fieldset": {
              borderColor: "#667eea",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#667eea",
            },
          },
        }}
      />
      {searchQuery && !loading && !tabLoading && (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ mt: 1, display: "block" }}
        >
          Showing {resultsCount} result{resultsCount !== 1 ? "s" : ""} for "
          {searchQuery}"
        </Typography>
      )}
    </Paper>
  );
};

export default SearchBar;